import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Geolocation } from "@capacitor/geolocation";
import RouteList from "./RouteList";

import "../assets/scss/app.scss";
import currentLocation from "../providers/currentLocation";

const queryClient = new QueryClient();

export default function Routers() {
	useEffect(() => {
		let watchId = null;

		const startTracking = async () => {
			try {
				// Immediate initial location fetch to prompt permission and store coords
				const loc = await currentLocation();
				if (loc && loc.coords && loc.coords.latitude && loc.coords.longitude) {
					localStorage.setItem("currentLocations", JSON.stringify(loc));
					localStorage.setItem("currentLocation", JSON.stringify(loc));
				}
			} catch (err) {
				console.warn("Initial location tracking error:", err);
			}

			// Watch surveyor location continuously while app is open
			try {
				watchId = await Geolocation.watchPosition(
					{
						enableHighAccuracy: true,
						timeout: 10000,
						maximumAge: 5000,
					},
					(position, err) => {
						if (position && position.coords) {
							const json = JSON.stringify(position);
							localStorage.setItem("currentLocations", json);
							localStorage.setItem("currentLocation", json);
						}
					}
				);
			} catch (err) {
				console.warn("Geolocation watchPosition not available:", err);
			}
		};

		startTracking();

		// Periodic background refresh every 20 seconds
		const intervalId = setInterval(async () => {
			try {
				await currentLocation();
			} catch (e) {}
		}, 20000);

		return () => {
			if (watchId) {
				try {
					Geolocation.clearWatch({ id: watchId });
				} catch (e) {}
			}
			clearInterval(intervalId);
		};
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<Router
				future={{
					v7_relativeSplatPath: true,
					v7_startTransition: true,
				}}
			>
				<RouteList />
			</Router>
		</QueryClientProvider>
	);
}
